export const defaultUserRoles = {
  group: 'Select Group',
  department: 'Select Department',
  role: 'Select Role',
};
